// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","466":"component---src-pages-docs-mdx-slug-js"}[chunkId] + "-" + {"125":"2a0381e6e97ec0e7f82a","293":"2e41b036938f8cf031a1","466":"f5d11e3f2fcf6738f207"}[chunkId] + ".js";
};